import { gql } from '@apollo/client';

//TODO: Still some types to add to this query like ClassroomSettings
const CLASSROOM_FRAGMENT = gql`
  fragment BaseClassroom on Classroom {
    id
    sisId
    name
    color
    loginType
    organizationId
    academicSessionId
    dateArchived
    dateRemoved
  }
`;

export default CLASSROOM_FRAGMENT;
